import {
  CONFIG_ENDPOINT,
  PATIENT_DATA_ENDPOINT,
  ORGANIZATION_DATA_ENDPOINT,
  RESOURCES_DATA_ENDPOINT,
  USER_INFO_ENDPOINT,
  JWS_KEYS_ENDPOINT,
  REPORTS_ENDPOINT,
  SIMILAR_RESOURCE_SEARCH_ENDPOINT
} from './constants';
import {PATIENT} from '../constants';
import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react';

export const configApi = createApi({
  reducerPath: 'configApi',
  baseQuery: fetchBaseQuery({baseUrl: '/'}),
  endpoints: (builder) => ({
    getConfig: builder.query({
      query: () => CONFIG_ENDPOINT
    })
  })
});

const dynamicBaseDvzaSupportConsoleServiceQuery = async (args, api, extraOptions) => {
  const dvzaSupportConsoleServiceUrl = api.getState().app.config.dvzaSupportConsoleServiceUrl;
  const rawBaseQuery = fetchBaseQuery({
    baseUrl: dvzaSupportConsoleServiceUrl,
    prepareHeaders: (headers, {getState}) => {
      const token = getState().app.accessToken;
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    }
  });
  return rawBaseQuery(args, api, extraOptions);
};

export const dvzaSupportConsoleServiceApi = createApi({
  reducerPath: 'dvzaSupportConsoleServiceApi',
  baseQuery: dynamicBaseDvzaSupportConsoleServiceQuery,
  endpoints: (builder) => ({
    getData: builder.query({
      query: ({
        inputData,
        inputDataType,
        optionalOrganizationSearchParameter,
        optionalOrganizationSearchParameterType
      }) => {
        const endpoint = inputDataType.group === PATIENT ? `${PATIENT_DATA_ENDPOINT}` : `${ORGANIZATION_DATA_ENDPOINT}`;
        const optionParameterQuery =
          optionalOrganizationSearchParameter != '' &&
          (optionalOrganizationSearchParameterType.idType === 'fhirId'
            ? `managing-organization=${optionalOrganizationSearchParameter}&`
            : `managing-organization=${encodeURIComponent(
                optionalOrganizationSearchParameterType.id
              )}|${optionalOrganizationSearchParameter}&`);

        const queryParams =
          inputDataType.idType === 'fhirId'
            ? `id=${inputData}`
            : `${optionParameterQuery == false ? '' : optionParameterQuery}identifier=${encodeURIComponent(
                inputDataType.id + '|' + inputData
              )}`;
        return `${endpoint}?${queryParams}`;
      }
    }),
    getNextPage: builder.query({
      query: (nextPageLink) => {
        const nextPageUrl = new URL(nextPageLink);
        const nextPageUrlPathname = nextPageUrl.pathname;
        const nextPageUrlIdentifier = nextPageUrl.searchParams.get('identifier');

        return `${nextPageUrlPathname}${nextPageUrl.search.replace(
          nextPageUrlIdentifier,
          encodeURIComponent(nextPageUrlIdentifier)
        )}`;
      }
    }),
    getResourcesData: builder.query({
      query: ({patientId, resourceType}) => {
        return `${RESOURCES_DATA_ENDPOINT}?patient-id=${patientId}&resource-type=${resourceType}`;
      }
    }),
    getResourcesDataNextPage: builder.query({
      query: (nextPageLink) => {
        const nextPageUrl = new URL(nextPageLink);
        const nextPageUrlPathname = nextPageUrl.pathname;
        return `${nextPageUrlPathname}${nextPageUrl.search}`;
      }
    }),
    getSimilarResourceSearch: builder.query({
      query: ({resourceType, id, identifierSystem}) => {
        return `${SIMILAR_RESOURCE_SEARCH_ENDPOINT}?id=${id}&resource-type=${resourceType}&identifier-system=${encodeURIComponent(identifierSystem)}`;
      }
    }),
    getReport: builder.query({
      query: (reportId) => ({url: `${REPORTS_ENDPOINT}?id=${reportId}`, responseHandler: (response) => response.text()})
    })    
  })
});

const dinamycOpenIdConnectBaseUrlQuery = async (args, api, extraOptions) => {
  const openIdConnectBaseUrl = api.getState().app.config.openId.openIdConnectBaseUrl;
  const rawBaseQuery = fetchBaseQuery({
    baseUrl: openIdConnectBaseUrl,
    prepareHeaders: (headers, {getState}) => {
      const token = getState().app.accessToken;

      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }

      return headers;
    }
  });
  return rawBaseQuery(args, api, extraOptions);
};

export const openIdConnectBaseApi = createApi({
  reducerPath: 'openIdConnectBaseApi',
  baseQuery: dinamycOpenIdConnectBaseUrlQuery,
  endpoints: (builder) => ({
    getUserInfo: builder.query({
      query: () => ({url: USER_INFO_ENDPOINT, responseHandler: (response) => response.text()})
    }),
    getJwsKeys: builder.query({
      query: () => JWS_KEYS_ENDPOINT
    })
  })
});

export const {useGetConfigQuery} = configApi;
export const {useLazyGetUserInfoQuery, useLazyGetJwsKeysQuery} = openIdConnectBaseApi;
export const {
  useLazyGetDataQuery,
  useLazyGetNextPageQuery,
  useLazyGetResourcesDataQuery,
  useLazyGetResourcesDataNextPageQuery,
  useLazyGetReportQuery,
  useLazyGetSimilarResourceSearchQuery
} = dvzaSupportConsoleServiceApi;
